var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar fixed-top navbar-expand-lg navbar-light bg-white fixed-top"},[_c('div',{staticClass:"container container-header-footer"},[_c('a',{staticClass:"navbar-brand linkhome",attrs:{"href":_vm.VUE_APP_LINKHOME}},[_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.img_sct_outil.src,"title":_vm.HTMLTITLE}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }